import React from "react";

interface CheckboxToggleProps {
  label?: string;
  checked: boolean;
  onChange: () => void;
  size?: number;
  fontSize?: number | string;
}

const FormatJsonCheckBox: React.FC<CheckboxToggleProps> = ({
  label = "Format JSON",
  checked,
  onChange,
  size = 14,
  fontSize = 14,
}) => {
  return (
    <div className="form-check d-flex justify-content-center">
      <input
        className="form-check-input"
        type="checkbox"
        id="formatJsonCheck"
        checked={checked}
        onChange={onChange}
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      />
      <label
        className="form-check-label ms-2"
        htmlFor="formatJsonCheck"
        style={{ fontSize }}
      >
        {label}
      </label>
    </div>
  );
};

export default FormatJsonCheckBox;
